var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottomList"},_vm._l((_vm.bottomTips),function(item){return _c('div',{key:item.label,staticClass:"item",on:{"click":function($event){return _vm.goOtherWeb(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }